import { useState, useEffect } from "react";
import styles from "./myprofile.module.css";
import { authData, authCustomerData, withCustomerAuth } from "../../../admin/components/GetAuth";
import { Link as RouterLink } from "react-router-dom";
import dayjs from "dayjs";
import SideBar from "../../components/sideBar";
import CopyToClipboard from "react-copy-to-clipboard";
import { Tooltip } from "@mui/material";
import { Copy } from "react-feather";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import { withHttps } from "../../../utils/siteUrl";

function MyProfile() {
  const authCustomer = authCustomerData();
  const [customerLink, setCustomerLink] = useState("");

  const { websiteData } = useWebsite();
  useSiteBranding("My profile", websiteData);

  useEffect(() => {
    if (authData() && authCustomerData()?.reference_token) {
      setCustomerLink(withHttps(authData()?.company?.domain) + '/customer-sign-up/' + authCustomerData()?.reference_token + '/' + authData()?.company?.urltoken);
    }
  }, []);

  return (<div className={`${styles.MainDivCustomer}`}>
    <div className={`${styles.Container}`}>
      <div className={`${styles.CusRow}`}>
        <div className={`${styles.CustomerSideBar}`}><SideBar /></div>
        <div className={`${styles.CustomerDeSec}`}>
          <div className={`${styles.UserProCard2}`}>

            <div className={`${styles.UserHead}`}>
              <div>
                <p className={styles.PageHeadEyebrow}>Account</p>
                <p className={`${styles.UserProName}`}>{authCustomer?.name}</p>
                <p className={styles.UserHeadSub}>Customer ID: {authCustomer?.customer_id}</p>
              </div>
              <div className={styles.HeadActions}>
                <RouterLink className={`${styles.SideEditBU} ${styles.SideEditBU3}`} to={"/customer/change-password"}>Change Password</RouterLink>
                <RouterLink className={`${styles.SideEditBU} ${styles.SideEditBU2}`} to={"/customer/update-profile"}>Edit Profile</RouterLink>
              </div>
            </div>

            <div className={`${styles.UserProDe}`}>

              <div className={styles.DetailCol}>
                <p className={styles.DetailTitle}>Personal details</p>
                <p className={`${styles.UserProDeList}`}>
                  <span>Customer Id</span> {authCustomer?.customer_id}
                </p>
                <p className={`${styles.UserProDeList}`}>
                  <span>Name</span> {authCustomer?.name}
                </p>
                <p className={`${styles.UserProDeList}`}>
                  <span>Email</span> {authCustomer?.email}
                </p>
                <p className={`${styles.UserProDeList}`}>
                  <span>Phone No</span> {authCustomer?.phone}
                </p>
                <p className={`${styles.UserProDeList}`}>
                  <span>Date Of Birth</span> {dayjs(authCustomer?.dob).format("DD/MM/YYYY")}
                </p>
              </div>

              <div className={styles.DetailCol}>
                <p className={styles.DetailTitle}>Address</p>
                <p className={`${styles.UserProDeList}`}>
                  <span>Address</span> {authCustomer?.address}
                </p>
                <p className={`${styles.UserProDeList}`}>
                  <span>Post Code</span> {authCustomer?.post_code}
                </p>
                <p className={`${styles.UserProDeList} ${styles.UserProDeList2}`}>
                  <span>Registered company?</span> {authCustomer?.registered_company}
                </p>
                {authCustomer?.registered_company === "Yes" && (<>
                  <p className={`${styles.UserProDeList} ${styles.UserProDeList2}`}>
                    <span>Shipping in company name?</span> {authCustomer?.company_shipping}
                  </p>
                  <p className={`${styles.UserProDeList} ${styles.UserProDeList2}`}>
                    <span>Company name</span> {authCustomer?.company_name}
                  </p>
                </>)}
              </div>

              <div className={styles.RefCard}>
                <p className={styles.DetailTitle}>Referral link</p>
                <div className={styles.RefBox}>
                  <CopyToClipboard text={customerLink}>
                    <Tooltip title={"Click to copy"}>
                      <span className={styles.RefLink}>{customerLink}</span>
                    </Tooltip>
                  </CopyToClipboard>
                  <CopyToClipboard text={customerLink}>
                    <Tooltip title={"Click to copy"}>
                      <button type="button" className={styles.RefCopyBU} aria-label="Copy referral link">
                        <Copy />
                      </button>
                    </Tooltip>
                  </CopyToClipboard>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>);
}

export default withCustomerAuth(MyProfile);